// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sl-spinner[data-v-63dcb183]{border-style:solid;transform:translateZ(0);animation-iteration-count:infinite;animation-timing-function:linear;border-radius:50%;width:30px;height:30px}@keyframes forward-63dcb183{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
